import SubHeader from "../components/Subheader";
import TheoryOptions from "../features/TheoryOptions";

const TheoryPage = () => {
  return (
    <div>
      <SubHeader current="Theory Page" />
      <TheoryOptions />
    </div>
  );
};

export default TheoryPage;
